import { SortOption } from '../../../../../ui/components/baseTable/dtos/SortOption.dto'
import { TableColumn } from '../../../../../ui/components/baseTable/dtos/TableColumn.dto'

export class AlertSettingsTableColumnsFactory {
	static make(sortOptions: SortOption[]): TableColumn[] {
		return [
			{
				name: 'Código',
				key: 'code',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'code')?.direction,
			},
			{
				name: 'Descrição',
				key: 'description',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'description')?.direction,
			},
			{
				name: 'Fazenda/setor',
				key: 'monitoredArea',
			},
			{
				name: 'Buffer (km)',
				key: 'buffer',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'buffer')?.direction,
			},
			{
				name: 'Confiança da detecção',
				key: 'minDetectionConfidence',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'minDetectionConfidence')?.direction,
			},
		]
	}
}
